import { getDeviceId } from '@/core/analytics/analytics'
import { getCurrentLanguage } from '@/core/i18n'
import { appToBackendLanguage, type LanguageCode } from '@/core/i18n/languages'

/**
 * Build an external theleaply.com URL with locale in path and deviceId param.
 *
 * Always produces: theleaply.com/{locale}/...?deviceId=...
 *
 * The path locale uses the website slug form (`appToBackendLanguage`), so the
 * Portuguese variants map to the slugs the site serves: pt-BR → br, pt-PT → pt.
 */
export function buildExternalUrl(base: string): string {
  const locale = appToBackendLanguage(getCurrentLanguage() as LanguageCode)
  const url = new URL(base)

  // Replace existing locale segment or prepend one
  const hasLocale = /^\/[a-z]{2}(-[a-zA-Z]{2,4})?(\/|$)/.test(url.pathname)
  if (hasLocale) {
    url.pathname = url.pathname.replace(
      /^\/[a-z]{2}(-[a-zA-Z]{2,4})?/,
      `/${locale}`,
    )
  } else {
    url.pathname = `/${locale}${url.pathname}`
  }

  url.searchParams.set('deviceId', getDeviceId())
  url.searchParams.set('utm_source', 'app_web')

  return url.toString()
}
